
export const newCriminal = [
  {
    name:'Section A',
    label:'SECTION A: Docket',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionA'
    }
  },
  /*  */
  {
    name:'01_cases_carried_over_term_label',
    label:'1. Number of cases carried over from previous term',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'01_cases_carried_over_term',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
  {
    name:'02_cases_carried_over_term_label',
    label:'2. Number of new cases arriving onto the docket during current term',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'02_cases_carried_over_term',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
   /*  */
  {
    name:'03_cases_listed_current_term_label',
    label:'3. Number of cases listed in total during current term',
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'03_cases_listed_current_term',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
/*  */
{
  name:'04_cases_finished_during_current_term_label',
  label:'4. Number of cases finished during current term',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'04_cases_finished_during_current_term',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
  /*  */
{
  name:'05_carried_over_to_next_term_label',
  label:'5. Number of cases carried over to next term',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'05_carried_over_to_next_term',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'Section B',
  label:'SECTION B: Court Output',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionB'
  }
},
/*  */
{
  name:'06_cases_involving_children_label',
  label:'6.	Number of cases involving children',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'06_cases_involving_children',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'07_number_of_bail_applications_label',
  label:'7. Number of bail applications ',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'07_number_of_bail_applications',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'08_number_of_discontinuances_label',
  label:'8.	Number of discontinuances',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'08_number_of_discontinuances',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'09_number_of_pleas_label',
  label:'9.	Number of pleas',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'09_number_of_pleas',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'10_number_of_sentences_label',
  label:'10. Number of sentences',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'10_number_of_sentences',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value ',
},
/*  */
{
  name:'11_number_of_trials_started_label',
  label:'11. Number of trials started',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'11_number_of_trials_started',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
  /*  */
 {
  name:'12_number_of_trials_completed_to_verdict_label',
  label:'12. Number of trials completed to verdict',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'12_number_of_trials_completed_to_verdict',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'13_a_Number_of_trials_awaiting_finalization_by_sentencing_after_verdict_label',
  label:'13. (a) Number of trials awaiting finalization by sentencing after verdict',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'13_a_Number_of_trials_awaiting_finalization_by_sentencing_after_verdict',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
{
  name:'13_b_number_of_trials_awaiting_sentencing_for_3_months_or_more_than_3_months_after_verdict_label',
  label:'(b) Number of trials awaiting sentencing for 3 months or more than 3 months after verdict ',
  type:'label',
  layout:'col description sub-indent drag-line',
},
{
  name:'13_b_number_of_trials_awaiting_sentencing_for_3_months_or_more_than_3_months_after_verdict',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
{
  name:'14_a_Tttal_number_of_matters_awaiting_sentence_after_a_guilty_plea_label',
  label:'14.	(a) Total number of matters awaiting sentence after a guilty plea',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'14_a_Tttal_number_of_matters_awaiting_sentence_after_a_guilty_plea',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'14_b_number_of_matters_awaiting_sentence_for_3_months_or_more_after_a_guilty_plea_label',
  label:'(b) Number of matters awaiting sentence for 3 months or more after a guilty plea',
  type:'label',
  layout:'col description sub-indent drag-line',
},
{
  name:'14_b_number_of_matters_awaiting_sentence_for_3_months_or_more_after_a_guilty_plea',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/* */
{
  name:'15_number_of_trials_adjourned_label',
  label:'15. Number of trials adjourned',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'15_number_of_trials_adjourned',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
 /* */
 {
  name:'16_reasons_for_adjournments_label',
  label:`16. Reasons for adjournments <br><span class="red-text">(Enter values only for the first adjournment)</span>`,
  type:'label',
  layout:'col s12',
},
{
  name:'16_reasons_for_adjournments',
  label:'',
  type:'data_table',
  header:['Reason', 'Total'],
  add_placeholder:'Reason',
  add_button_caption: 'Add Reasons',
  other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
  show_total: true,
  values:[
    { 
      reason: "To obtain legal representation", 
      total: 0
    },
    { 
      reason: "For plea discussion", 
      total: 0
    },
    { 
      reason: "Due to absence of attorney", 
      total: 0
    },
    { 
      reason: "Due to absence of witnesses", 
      total: 0
    },
    { 
      reason: "Due to another trial", 
      total: 0
    },
    { 
      reason: "Due to disclosure", 
      total: 0
    },
    { 
      reason: "For further case management", 
      total: 0
    },
    { 
      reason: "For Court closure", 
      total: 0
    },
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},

  /*  */
  {
    name:'17_how_many_trials_were_adjourned_label',
    label:'17. How many trials were adjourned?',
    type:'label',
    layout:'col description',
  },
  {
    name:'17_how_many_trials_have_lasted',
    label:'',
    type:'data_table',
    values:[

      {
      reason: "Two times",
      total:0
      },
      {
        reason: "Three times",
        total:0
      },
      {
        reason: "Four times",
        total:0
      },
      {
      reason: "More than 4 times",
      total:0
      },
    ],
    can_add: false,
    readonly:false,
    layout:'col s12',
  },
  /*  */

/*  */
{
  name:'18_what_were_the_main_reasons_for_the_further_adjournments_label',
  label:'18. What were the main reasons for the further adjournments?',
  type:'label',
  layout:'col 12',
},
{
  name:'18_what_were_the_main_reasons_for_the_further_adjournments',
  label:'',
  type:'text_area',
  values:'',
  readonly:false,
  layout:'col s12',
},
/* 17 18 */
/*  */
{
  name:'19_nature_of_cases_listed_label',
  label:'19. Nature of cases listed (List below, example: 4 burglary, 3 assault)',
  type:'label',
  layout:'col description',
},
/* {
  name:'17_nature_of_cases_listed',
  label:'',
  type:'text_area',
  values:'',
  readonly:false,
  layout:'col s12',
}, */
{
  name:'19_nature_of_cases_listed',
  label:'',
  type:'data_table',
  header:['Nature of cases', 'Total'],
  other_label: 'Add Item',
  show_total: false,
  add_button_caption: 'Add Item',
  values:[
    { 
      reason: "Assault", 
      total: 0
    },
    { 
      reason: "Indecent assault", 
      total: 0
    },
    { 
      reason: "Illegal possession of firearm", 
      total: 0
    },
    { 
      reason: "Rape", 
      total: 0
    },
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},
/*  */
{
  name:'20_how_many_trials_have_lasted_label',
  label:'20. How many trials have lasted: (Please clearly indicate your response)',
  type:'label',
  layout:'col description',
},
{
  name:'20_how_many_trials_have_lasted',
  label:'',
  type:'data_table',
  values:[
    {
      reason:"Up to 2 Days?",
      total: 0,
    },
    {
      reason:"Up to 5 Days?",
      total: 0,
    },
    {
      reason:"Up to 10 Days?",
      total: 0,
    },
    {
      reason:"More than 10 Days?",
      total: 0,
    }
  ],
  can_add: false,
  readonly:false,
  layout:'col s12',
},
/*  */
{
  name:'Section C',
  label:'SECTION C: Decisions',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionC'
  }
},
/*  */
{
  name:'21_number_of_oral_judgments_delivered_label',
  label:'21. Number of oral judgments delivered',
  type:'label',
  layout:'col description drag-line',
},
{
  name:'21_number_of_oral_judgments_delivered',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
  /*  */
{
  name:'22_number_of_written_judgments_delivered_label',
  label:'22. Number of written judgments delivered',
  type:'label',
  layout:'col description  drag-line',
},
{
  name:'22_number_of_written_judgments_delivered',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'Section D',
  label:'SECTION D: COMMENTS',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionD'
  }
},
/*  */
{
  name:'23_comments_label',
  label:'23. comments',
  type:'label',
  layout:'col 12',
},
{
  name:'23_comments',
  label:'',
  type:'text_area',
  values:'',
  readonly:false,
  layout:'col s12',
},
//end of record
]
export const newCivil = [
  {
    name:'Section A',
    label:'SECTION A: Trials',
    type:'label',
    layout:'col s12 section-title',
    anchorLink:{
      status: true,
      id:'sectionA'
    }
  },
  /*  */
  {
    name:'01_trials_scheduled_label',
    label:'1. Number of trials scheduled:',
    type:'label',
    layout:'col s12',
  },
  {
    name:'01_trials_scheduled_civil',
    label:'Civil',
    type:'number',
    values:'',
    readonly:false,
    layout:'col s6 input-field',
  },
  {
    name:'01_trials_scheduled_commercial',
    label:'Commercial',
    type:'number',
    values:'',
    readonly:false,
    layout:'col s6 input-field',
  },
  /*  */
  {
    name:'02_trials_completed_disposed_label',
    label:'2. Number of trials completed/disposed:',
    type:'label',
    layout:'col s12',
  },
  {
    name:'02_trials_completed_disposed_civil',
    label:'Civil',
    type:'number',
    values:'',
    readonly:false,
    layout:'col s6 input-field',
  },
  {
    name:'02_trials_completed_disposed_commercial',
    label:'Commercial',
    type:'number',
    values:'',
    readonly:false,
    layout:'col s6 input-field',
  },
/*  */
{
name:'3_a_number_of_trials_adjourned_label',
label:'3 (a) Number of trials adjourned',
type:'label',
layout:'col s12',
},
{
name:'3_a_number_of_trials_adjourned_civil',
label:'Civil',
type:'number',
values:'',
readonly:false,
layout:'col s6 input-field',
},
{
name:'3_a_number_of_trials_adjourned_commercial',
label:'Commercial',
type:'number',
values:'',
readonly:false,
layout:'col s6 input-field',
},
/*  */
{
name:'3_b_how_many_adjourned_trials_were_part_heard',
label:` &nbsp; &nbsp; (b) How many <b>of the adjourned trials</b> were part heard?`,
type:'label',
layout:'col s12',
},
{
name:'3_b_how_many_adjourned_trials_were_part_heard_civil',
label:'Civil',
type:'number',
values:'',
readonly:false,
layout:'col s6 input-field ',
},
{
name:'3_b_how_many_adjourned_trials_were_part_heard_commercial',
label:'Commercial',
type:'number',
values:'',
readonly:false,
layout:'col s6 input-field ',
},
/*  */
{
name:'3_c_reasons_for_adjournments_label',
label:`&nbsp; &nbsp; (c) Reasons for adjournments <br> &nbsp; &nbsp;  <span class="red-text">(Enter values only for the first adjournment)</span>`,
type:'label',
layout:'col s12',
},
{
name:'3_c_reasons_for_adjournments',
label:'',
type:'data_table',
add_placeholder:'Reason',
header:['Reason', 'Number'],
add_button_caption: 'Add Reasons',
other_label: `<span class="blue-text text-accent-4">State additional reasons</span`,
show_total: true,
values:[
  { 
    reason: "Absence of attorney",
    total: 0,
  },
  { 
    reason: "Absence of party/parties",
    total: 0,
  },
  { 
    reason: "For further case management",
    total: 0,
  },
  { 
    reason: "For outcome of mediation",
    total: 0,
  },
  { 
    reason: "For report",
    total: 0,
  },
  { 
    reason: "For review",
    total: 0,
  },
  { 
    reason: "For settlement discussions",
    total: 0,
  },
  { 
    reason: "Unavailability of courtroom",
    total: 0,
  },
  { 
    reason: "Unavailability of dates",
    total: 0,
  },
  { 
    reason: "For further directions/order",
    total: 0,
  },
],
can_add: true,
readonly:false,
layout:'col s12',
},
/*  */

{
name:'3_d_how_many_trials_were_adjourned_label',
label:`&nbsp; &nbsp; (d) How many trials were adjourned?`,
type:'label',
layout:'col description drag-line',
},
{
name:'3_d_how_many_trials_were_adjourned',
label:'',
type:'data_table',
values:[
  {
    reason:"Two Times",
    total: 0,
  },
  {
    reason:"Three times",
    total: 0,
  },
  {
    reason:"Four times",
    total: 0,
  },
  {
    reason:"More than 4 times",
    total: 0,
  }
],
can_add: false,
readonly:false,
layout:'col s12',
},

/*  */

{
name:'3_e_what_were_the_primary_reasons_for_the_further_adjournments_label',
label:`&nbsp; &nbsp; (e) What were the primary reasons for the further adjournments?`,
type:'label',
layout:'col 12',
},
{
name:'3_e_what_were_the_primary_reasons_for_the_further_adjournment',
label:'',
type:'text_area',
values:'',
readonly:false,
layout:'col s12',
},

/*  */

{
name:'4_how_many_trials_have_lasted_label',
label:'4. How many trials have lasted: (Please clearly indicate your responses)',
type:'label',
layout:'col description drag-line',
},
{
name:'how_many_trials_have_lasted',
label:'',
type:'data_table',
values:[
  {
    reason:"Up to 2 Days?",
    total: 0,
  },
  {
    reason:"Up to 5 Days?",
    total: 0,
  },
  {
    reason:"Up to 10 Days?",
    total: 0,
  },
  {
    reason:"More than 10 Days?",
    total: 0,
  }
],
can_add: false,
readonly:false,
layout:'col s12',
},
/*  */
{
name:'Section B',
label:'SECTION B: JUDGMENTS AFTER TRIAL',
type:'label',
layout:'col s12 section-title',
anchorLink:{
  status: true,
  id:'sectionB'
}
},
/*  */
{
name:'01_number_of_written_judgments_delivered_label',
label:'1. Number of written judgments delivered',
icon:{
  value:'help',
  active: true,
},
type:'label',
layout:'col description drag-line',
},
{
name:'01_number_of_written_judgments_delivered',
label:'',
type:'number',
values:'',
readonly:false,
layout:'col number-value',
},
/*  */
{
name:'02_number_of_oral_judgments_delivered_label',
label:'2. Number of oral judgments delivered',
type:'label',
layout:'col description drag-line',
},
{
name:'02_number_of_oral_judgments_delivered',
label:'',
type:'number',
values:'',
readonly:false,
layout:'col number-value',
},
/*  */
{
name:'Section C',
label:'SECTION C: OPEN COURT AND CHAMBER MATTERS',
type:'label',
layout:'col s12 section-title',
anchorLink:{
  status: true,
  id:'sectionC'
}
},
/*  */
{
name: '01_Number_of_matters_scheduled_listed_label',
label: "1. Number of matters scheduled/listed",
type:'label',
layout:'col description drag-line',
},
{
name: '01_Number_of_matters_scheduled_listed',
label:"",
type:'number',
values:'',
readonly:false,
layout:'col number-value',
},
/*  */
{
name: '02_Number_of_matters_where_decisions_were_reserved_label',
label: "2. Number of matters where decisions were reserved",
type:'label',
layout:'col description drag-line',
},
{
name: '02_Number_of_matters_where_decisions_were_reserved',
label:"",
type:'number',
values:'',
readonly:false,
layout:'col number-value',
},
/*  */
{
name: '03_Number_of_oral_decisions_delivered_label',
label: "3. Number of oral decisions delivered",
type:'label',
layout:'col description drag-line',
},
{
name: '03_Number_of_oral_decisions_delivered',
label:"",
type:'number',
values:'',
readonly:false,
layout:'col number-value',
},
/*  */
{
name: '04_Number_of_written_decisions_delivered_label',
label: "4. Number of written decisions delivered",
type:'label',
layout:'col description drag-line',
},
{
name: '04_Number_of_written_decisions_delivered',
label:"",
type:'number',
values:'',
readonly:false,
layout:'col number-value',
},
/*  */
{
name: '05_a_Reasons_for_adjournment_of_matters_label',
label: `5. (a) Reasons for adjournment of matters <br><span class="red-text">(Enter values only for the first adjournment)</span>`,
type:'label',
layout:'col 12',
},
{
name:'05_a_Reasons_for_adjournment_of_matters',
label:'',
type:'data_table',
header:['Reason for adjournment', 'Number'],
other_label: `<span class="blue-text text-accent-4">State additional reasons</span>`,
add_placeholder:'Reason',
add_button_caption: 'Add Reasons',
show_total: true,
values:[
  {
    reason: "Absence of attorney",
    total: 0,
  },
  {
    reason: "Absence of party/parties",
    total: 0,
  },
  {
    reason: "Bench warrant issued",
    total: 0,
  },
  {
    reason: "Defendant to retain counsel",
    total: 0,
  },
  {
    reason: "Due to lack of disclosure",
    total: 0,
  },
  {
    reason: "For directions/further directions/order",
    total: 0,
  },
  {
    reason: "For further case management",
    total: 0,
  },
  {
    reason: "For outcome of mediation",
    total: 0,
  },
  {
    reason: "For settlement discussions",
    total: 0,
  },
  {
    reason: "For review of terms of orders",
    total: 0,
  },
  {
    reason: "Stayed",
    total: 0,
  },
  {
    reason: "To allow for service on the claimant/defendant",
    total: 0,
  },
  {
    reason: "Unavailability of Courtroom",
    total: 0,
  },
  {
    reason: "Unavailability of dates",
    total: 0,
  },
  {
    reason: "Unavailability of judge",
    total: 0,
  },
],
can_add: true,
readonly:false,
layout:'col s12',
},
/*  */

{
name:'5_b_what_were_the_primary_reasons_for_any_further_adjournments_label',
label:`&nbsp; &nbsp; (b) What were the primary reasons for any further adjournments`,
type:'label',
layout:'col 12',
},
{
name:'5_b_what_were_the_primary_reasons_for_any_further_adjournments',
label:'',
type:'text_area',
values:'',
readonly:false,
layout:'col s12',
},


/*  */
{
name: '06_number_of_matters_completed_disposed_of_label',
label: "6. Number of matters completed/disposed",
type:'label',
layout:'col 12',
},
{
name:'06_number_of_matters_completed_disposed_of',
label:'',
type:'data_table',
add_placeholder:'Method',
add_button_caption: 'Add method',
header:['Method of disposal', 'Number'],
other_label: `<span class="blue-text text-accent-4">Additional methods of dispossal</span>`,
show_total: true,
values:[
  { 
    reason: "Consent Order",
    total: 0,
  },
  { 
    reason: "Discontinued/withdrawn",
    total: 0,
  },
  { 
    reason: "Dismissed for want of prosecution",
    total: 0,
  },
  { 
    reason: "Struck Out",
    total: 0,
  },
  { 
    reason: "Settled",
    total: 0,
  },
  { 
    reason: "Mediation Agreement",
    total: 0,
  },
  { 
    reason: "Satisfaction",
    total: 0,
  },
  { 
    reason: "Order Granted as Prayed",
    total: 0,
  },
  { 
    reason: "Application Refused",
    total: 0,
  },
  { 
    reason: "Matter Removed from the list",
    total: 0,
  },
],
can_add: true,
readonly:false,
layout:'col s12',
},
/*  */
{
name:'Section E',
label:'SECTION E: DIVORCES',
type:'label',
layout:'col s12 section-title',
anchorLink:{
  status: true,
  id:'sectionE'
}
},
/*  */
{   
  name:'1_Number_of_Divorce_matters_matrimonial_applications_scheduled_listed_label',
  label: "1. Number of Divorce matters/Matrimonial applications scheduled/listed",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'1_Number_of_Divorce_matters_matrimonial_applications_scheduled_listed',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{ 
  name:'2_Number_of_Divorce_matters_Matrimonial_applications_adjourned_label',
  label: "2. Number of Divorce matters/ Matrimonial applications adjourned",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'2_Number_of_Divorce_matters_Matrimonial_applications_adjourned',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{ 
  name:'3_Number_of_Decrees_Nisi_granted_label',
  label: "3. Number of Decrees Nisi granted",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'3_Number_of_Decrees_Nisi_granted',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */

{ 
  name:'4_Number_of_decrees_absolute_label',
  label: "4. Number of Decrees Absolute ",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'4_Number_of_decrees_absolute',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},

/*  */
{ 
  name:'5_Number_of_Ancillary_matters_scheduled_listed_label',
  label: "5. Number of Ancillary matters scheduled/listed",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'5_Number_of_Ancillary_matters_scheduled_listed',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{ 
  name:'6_Number_of_Ancillary_matters_adjourned_label',
  label: "6. Number of Ancillary matters adjourned",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'6_Number_of_Ancillary_matters_adjourned',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{ 
  name:'07_Method_of_disposal_of_Ancillary_matters_label',
  label: "7. Method of disposal of Ancillary matters ",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'07_Method_of_disposal_of_Ancillary_matters',
  label:'',
  type:'data_table',
  header:['Method of disposal', 'Number'],
  other_label: 'Addtional methods (state with numbers)',
  show_total: true,
  values:[
    {
      reason: "Consent Order",
      total: 0
    },
    {
      reason: "Dismissed",
      total: 0
    },
    {
      reason: "Withdrawn",
      total: 0
    },
    {
      reason: "Discontinued",
      total: 0
    },
    {
      reason: "Settled",
      total: 0
    },
  /*   {
      reason: "Other (specify)",
      total: 0
    }, */
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},
/*  */
{ 
  name:'08_Reasons_for_adjournment_for_all_Divorce_matters_Divorce_ancillary_etc_label',
  label: `8. Reasons for adjournment for all Divorce matters (Divorce, ancillary etc): <br> <span class="red-text">(Enter values only for the first adjournment)</span>`,
  type:'label',
  layout:'col description drag-line',
},
{
  name:'08_Reasons_for_adjournment_for_all_Divorce_matters_Divorce_ancillary_etc',
  label:'',
  type:'data_table',
  header:['Reason for adjournment', 'Total'],
  other_label: 'Addtional reasons (specify)',
  show_total: true,
  values:[
    {
      reason: "Absence of attorney",
      total: 0
    },
    {
      reason: "For discussion",
      total: 0
    },
    {
      reason: "For the parties to pursue voluntary mediation",
      total: 0
    },
    {
      reason: "Non -service of the respondent",
      total: 0
    },
    {
      reason: "For further directions",
      total: 0
    },
    {
      reason: "For trial",
      total: 0
    },
  ],
  can_add: true,
  readonly:false,
  layout:'col s12',
},
/*  */
{
  name:'8_b_What_wer_the_primary_reason_for_any_further_adjournments_label',
  label:'(b) What were the primary reasons for any further adjournments?',
  type:'label',
  layout:'col 12',
},
{
  name:'8_b_What_wer_the_primary_reason_for_any_further_adjournments',
  label:'',
  type:'text_area',
  values:'',
  readonly:false,
  layout:'col s12',
},

/*  */
{
  name:'Section F',
  label:'SECTION F: APPLICATIONS WITHOUT NOTICE/EX- PARTE HEARINGS',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionF'
  }
  },
  /*  */
  { 
    name:'01_Number_of_applications_without_notice_dealt_with_label',
    label: "1. Number of applications without notice dealt with",
    type:'label',
    layout:'col description drag-line',
  },
  {
    name:'01_Number_of_applications_without_notice_dealt_with',
    label:'',
    type:'number',
    values:'',
    readonly:false,
    layout:'col number-value',
  },
  /*  */
{
  name:'Section G',
  label:'SECTION G: APPLICATIONS REVIEWED AND MADE IN ADMINISTRATION OF ESTATES AND PROBATES',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionG'
  }
},
/*  */
{ 
  name:'01_Number_of_applications_dealt_with_in_this_regard_label',
  label: "1. Number of applications dealt with in this regard",
  type:'label',
  layout:'col description drag-line',
},
{
  name:'01_Number_of_applications_dealt_with_in_this_regard',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col number-value',
},
/*  */
{
  name:'Section H',
  label:'SECTION H: OTHER APPLICATIONS (example land certificate/Certificate of Title matters)',
  type:'label',
  layout:'col s12 section-title',
  anchorLink:{
    status: true,
    id:'sectionH'
  }
},
/*  */
{ 
  name:'01_Number_of_applications_label',
  label: "1. Number of applications",
  type:'label',
  layout:'col',
},
{
  name:'01_Number_of_applications',
  label:'',
  type:'number',
  values:'',
  readonly:false,
  layout:'col',
},
{ 
  name:'01_of_type_label',
  label: "of type",
  type:'label',
  layout:'col ',
},
{
  name:'01_Number_of_applications_of_tyoe',
  label:'',
  type:'text',
  values:'',
  readonly:false,
  layout:'col clear',
},
/*  */

/*  */
{
  name:'21_comments_label',
  label:'Comments',
  type:'label',
  layout:'col 12',
},
{
  name:'21_comments',
  label:'',
  type:'text_area',
  values:'',
  readonly:false,
  layout:'col s12',
},
//end of record
]